import { useQuery } from "@tanstack/react-query";

import { apiClient } from "@/api/client";

import { notifKeys } from "./query-keys";

export function useSettings() {
  return useQuery({
    queryKey: notifKeys.settings(),
    queryFn: async () => {
      const { data, error } = await apiClient.GET("/v1/notifications/settings");
      if (error) throw error;
      return data;
    },
  });
}
